// Generated from auth/client/ by scripts/sync-auth-client.mjs. Do not edit here.
// Sign-in for this app, backed by the shared tafiti.dev session (see
// tafiti-auth.js and the auth/ service in the repo root).
//
// On *.tafiti.dev, sign-in happens on the shared sign-in page and lasts 60
// days; no Google tokens are kept in the browser. Everywhere else (drlugha.com,
// Vercel previews, localhost without VITE_AUTH_URL) the previous Google
// Identity Services sign-in in legacy-google-auth.js is used unchanged.
//
// Both expose the same methods, so the rest of the app doesn't care which.

import { tafitiAuth, usesSharedAuth } from './tafiti-auth.js';
import { googleAuthService as legacyGoogleAuthService } from './legacy-google-auth.js';

function toUserInfo(user) {
  if (!user) return null;
  return {
    id: user.id,
    email: user.email,
    name: user.name,
    givenName: user.givenName,
    imageUrl: user.picture,
  };
}

class SharedGoogleAuthService {
  constructor() {
    this.authStateCallbacks = [];
    tafitiAuth.subscribe(() => this.notifyAuthStateChange(this.isSignedIn()));
  }

  /** Ask the auth service who is signed in (once per page load). */
  async initialize() {
    await tafitiAuth.initialize();
    return this.isSignedIn();
  }

  isSignedIn() {
    return tafitiAuth.isSignedIn();
  }

  getUserInfo() {
    return toUserInfo(tafitiAuth.user);
  }

  /** The session cookie renews itself; this just re-checks it with the server. */
  async validateSession() {
    return tafitiAuth.refresh();
  }

  /** Goes to the shared sign-in page and comes back here. Doesn't resolve. */
  signIn() {
    tafitiAuth.signIn();
    return new Promise(() => {});
  }

  promptOneTap() {
    this.signIn();
  }

  /** Replaces the Google button with one that opens the shared sign-in page. */
  renderSignInButton(container) {
    if (!container) return;
    container.replaceChildren();
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'tafiti-signin-button';
    button.textContent = 'Sign in with Google';
    Object.assign(button.style, {
      minHeight: '48px',
      padding: '0 20px',
      borderRadius: '999px',
      border: '1px solid currentColor',
      background: 'transparent',
      font: 'inherit',
      fontWeight: '600',
      cursor: 'pointer',
    });
    button.addEventListener('click', () => this.signIn());
    container.appendChild(button);
  }

  async signOut() {
    await tafitiAuth.signOut();
  }

  /** No Google tokens are kept in the browser any more. */
  getAccessToken() {
    return null;
  }

  async getValidAccessToken() {
    return null;
  }

  onAuthStateChanged(callback) {
    this.authStateCallbacks.push(callback);
    callback(this.isSignedIn(), this.getUserInfo());
  }

  notifyAuthStateChange(isSignedIn) {
    this.authStateCallbacks.forEach((callback) => {
      try {
        callback(isSignedIn, this.getUserInfo());
      } catch (error) {
        console.error('Auth state callback error:', error);
      }
    });
  }
}

export const googleAuthService = usesSharedAuth() ? new SharedGoogleAuthService() : legacyGoogleAuthService;
